import React, { Component } from 'react';
import './css/popupstyle.css';
import Search_Icon from '../../src/components/css/dark/img/theme-images/search.svg'
import $ from 'jquery/dist/jquery.min.js';
import { userService } from '../_services';

const SCROLL_SECTION_LOADING = {
    CITY: false,
    ZIP: false,
    DRUG: false,
    PHARMACYNAME: false,
    PRESCRIBERNAME: false,
    GROUPNUMBER: false,
    DISTRIBUTOR: false,
    WHOLESALER: false
};

class CreateNewFilter extends React.Component {

    constructor(props) {
        super(props);
        var _roletype = '', _rolename = '';
        try {
            var userdata = JSON.parse(localStorage.getItem('user'));
            if (userdata.userrole == "Distributor" && userdata.wholesaler == "Avenel") {
                _roletype = "distributor";
                _rolename = userdata.paramsname;
            }
            else if (userdata.userrole == "Distributor" && userdata.wholesaler != "Avenel") {
                _roletype = "distributor";
                _rolename = userdata.paramsname;
            }
            else {
                _roletype = userdata.userrole;
                _rolename = userdata.paramsname;
            }
        }
        catch (error) { }
        this.state = {
            wname: this.props.wholesaler_name,
            userdata: JSON.parse(localStorage.getItem('user')),
            CityJson: [],
            StateJson: [],
            ZipJson: [],
            DrugJson: [],
            PharmacyJson: [],
            PrescriberJson: [],
            GroupNameJson: [],
            DistributorJson: [],
            WholesalerJson: [],
            PbmJson: [],
            BinJson: [],
            GroupPrefixJson: [],
            APICalled: false,
            loading: { ...SCROLL_SECTION_LOADING },
            RoleType: _roletype,
            RoleName: _rolename,
            PhZIPCODE: '',
            prescribe_status: false
        };
        this.isScrollLoading = {};
        this.canLoadMore = {};
        this.hasReachedEnd = {};
        this.handleCheckbox = this.handleCheckbox.bind(this);
    }

    isAnySectionLoading() {
        return Object.values(this.isScrollLoading).some(Boolean);
    }

    setSectionLoading(section, isLoading) {
        if (!section) return;
        this.setState(prev => ({
            loading: { ...prev.loading, [section]: isLoading }
        }));
    }

    clearSectionLoading(section) {
        if (section) {
            this.isScrollLoading[section] = false;
            this.setSectionLoading(section, false);
            return;
        }
        this.isScrollLoading = {};
        this.setState({ loading: { ...SCROLL_SECTION_LOADING } });
    }

    finishScrollLoading(section, hasMoreData) {
        this.clearSectionLoading(section);
        if (hasMoreData) {
            this.canLoadMore[section] = true;
        } else {
            this.canLoadMore[section] = false;
        }
    }

    mergeLazyLoadItems(targetArr, apidata) {
        const items = Array.isArray(apidata) ? apidata : [];
        const newArr = targetArr || [];
        let addedCount = 0;
        items.forEach((e1) => {
            if (newArr.filter(function (e) { return e.text == e1.text }).length < 1) {
                newArr.push(e1);
                addedCount++;
            }
        });
        return { newArr, addedCount };
    }

    getLazyLoadListState(stype) {
        const stateMap = {
            'CITY': 'CityJson',
            'ZIP': 'ZipJson',
            'DRUG': 'DrugJson',
            'PHARMACYNAME': 'PharmacyJson',
            'PRESCRIBERNAME': 'PrescriberJson',
            'GROUPNUMBER': 'GroupNameJson',
            'DISTRIBUTOR': 'DistributorJson',
            'WHOLESALER': 'WholesalerJson'
        };
        const stateKey = stateMap[stype];
        return stateKey ? { stateKey, list: this.state[stateKey] } : null;
    }

    fetchPrescriberInfo() {
        try {
            let whid = this.state.userdata.wholesaler_Id.toString();
            userService.WhPrescribeInfo(whid).then(
                apidata => {
                    try {
                        if (apidata.length > 0) {
                            this.setState({ prescribe_status: apidata[0]._IsPrescribeData });
                        }
                    }
                    catch (error) {
                    }
                }
            );
        }
        catch (error) {
        }
    }
    HandleCancelSaveFilter() {
        $('.save-filter-section').slideToggle();
        $('#errormsg').text("");
    }
    saveFilter() {
        $('.save-filter-section').slideToggle();
    }
    HandleSaveFilter = e => {
        $('#FilterNameText').removeClass('errorIcon');
        try {
            let CreatedTagJson = this.SelectedTagJsonBuilding();
            if ($('#FilterNameText').val() != null && $('#FilterNameText').val() != '' && $('#FilterNameText').val() != undefined) {
                if (userService.ValidateSpace($('#FilterNameText').val())) {
                    $('#FilterNameText').addClass('errorIcon');
                    $('#errormsg').text("Space not acceptable");

                } else {
                    if (CreatedTagJson != null && CreatedTagJson != "null" && CreatedTagJson != undefined && CreatedTagJson != undefined && CreatedTagJson != "") {
                        this.SaveFilterDetail($('#FilterNameText').val(), CreatedTagJson, this.state.userdata["dList"][0].dashboardId);
                    }
                    else {
                        $('#errormsg').text("Please make a selection above");
                    }
                }
            }
            else {
                $('#FilterNameText').css('border-color', 'red');
                $('#errormsg').text("Please enter a filter name");
                $('#FilterNameText').addClass('errorIcon');
            }
        }
        catch (error) {
            alert(error);
        }
    }

    SaveFilterDetail(FilterName, FilterJson, DashboardId) {
        $('.btn.first-one').prop('disabled', true);
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
                body: JSON.stringify({ FilterName, FilterJson, DashboardId })
            };
            return fetch(`/api/Filter/SaveUserAdFilter`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    if (apidata.length > 0) {
                        if (apidata[0].status_code == "-1") {
                            setTimeout(function () {
                                try {
                                    $('#errormsg').text(apidata[0].status_message);
                                    $('.save-filter-section').slideToggle();
                                    $('.btn.first-one').prop('disabled', false);
                                    this.props.closePopup();
                                }
                                catch (error) {
                                    $('.btn.first-one').prop('disabled', false);
                                }
                            }, 5000);
                        }
                        else {
                            try {
                                $('.save-filter-section').slideToggle();
                                $('.btn.first-one').prop('disabled', false);
                                this.props.closePopup();
                            }
                            catch (error) {
                                $('.btn.first-one').prop('disabled', false);
                            }
                        }
                    }
                });
        }
        catch (error) {
            $('.btn.first-one').prop('disabled', false);
        }
    }

    GetFilterRawDataDetail(username, usertype, whname, distributor_UserId) {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username, usertype, whname, distributor_UserId })
            };
            return fetch(`/api/Filter/OnLoadFilterData`, requestOptions)
                //return fetch(`/api/Filter/GeoFilterData`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        this.setState({
                            CityJson: apidata[0]["fcity"],
                            StateJson: apidata[0]["fstate"],
                            ZipJson: apidata[0]["fzip"],
                            DrugJson: apidata[0]["fdrug"],
                            PharmacyJson: apidata[0]["fpharmacy"],
                            PrescriberJson: apidata[0]["fprescriber"],
                            GroupNameJson: apidata[0]["groupNumber"],
                            DistributorJson: apidata[0]["distributor"],
                            WholesalerJson: apidata[0]["wholesaler"],
                            PbmJson: apidata[0]["fpbm"],
                            BinJson: apidata[0]["bin"],
                            GroupPrefixJson: apidata[0]["gnPrefix"]
                        });
                        //this.MakeListDistinct();
                    }
                    catch (error) {
                    }
                });
        }
        catch (error) {

        }
    }


    GetLazyLoadingData(Type, ToSkip) {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Type, ToSkip })
            };
            return fetch(`/api/Filter/LazyLoadingData`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        if (apidata.length > 0) {
                            if (Type == 'ZIP') {
                                for (let i = 0; i < apidata[0]["fzip"].length; i++) {
                                    this.state.ZipJson.push(apidata[0]["fzip"][i]);
                                }
                            }
                            else if (Type == 'CITY') {
                                for (let i = 0; i < apidata[0]["fcity"].length; i++) {
                                    this.state.CityJson.push(apidata[0]["fcity"][i]);
                                }
                            }
                            else if (Type == 'PHARMACYNAME') {
                                for (let i = 0; i < apidata[0]["fpharmacy"].length; i++) {
                                    this.state.PharmacyJson.push(apidata[0]["fpharmacy"][i]);
                                }
                            }
                            else if (Type == 'PRESCRIBERNAME') {
                                for (let i = 0; i < apidata[0]["fprescriber"].length; i++) {
                                    this.state.PrescriberJson.push(apidata[0]["fprescriber"][i]);
                                }
                            }

                            this.clearSectionLoading(Type);
                        }
                        else {
                            this.clearSectionLoading(Type);
                        }
                    }
                    catch (error) {
                        this.clearSectionLoading(Type);
                    }
                });
        }
        catch (error) {
            this.clearSectionLoading(Type);
        }
    }

    MakeListDistinct() {
        try {
            var newArr = [];
            try {
                this.state.GroupNameJson.map((e1, i1) => {
                    if (newArr.indexOf(e1.distributorName) === -1) {
                        newArr.push(e1.distributorName)
                    }
                });
                this.setState({ DistributorNameJson: newArr });
            }
            catch (error) { }
            try {
                newArr = [];
                this.state.GroupNameJson.map((e1, i1) => {
                    if (newArr.indexOf(e1.wholeSaler) === -1) {
                        newArr.push(e1.wholeSaler)
                    }
                });
                this.setState({ WholesalerNameJson: newArr });
            }
            catch (error) { }
        }
        catch (error) {
        }
    }


    MakeListDistinctType(ScrollType) {
        if (ScrollType == "DISTRIBUTOR") {
            try {
                var newArr = [];
                this.state.GroupNameJson.map((e1, i1) => {
                    if (newArr.indexOf(e1.distributorName) === -1) {
                        newArr.push(e1.distributorName)
                    }
                });
                this.setState({ DistributorNameJson: newArr });
            }
            catch (error) { }
        }
        if (ScrollType == "WHOLESALER") {
            try {
                newArr = [];
                this.state.GroupNameJson.map((e1, i1) => {
                    if (newArr.indexOf(e1.wholeSaler) === -1) {
                        newArr.push(e1.wholeSaler)
                    }
                });
                this.setState({ WholesalerNameJson: newArr });
            }
            catch (error) { }
        }
    }

    handleResponse(response) {
        return response.text().then(text => {
            try {
                const data = text ? JSON.parse(text) : [];
                return Array.isArray(data) ? data : [];
            }
            catch (error) {
                return [];
            }
        });
    }
    handleFilter_static(e) {
        try {
            let val = e.target.value.toLowerCase();
            let TargetId = $(e.target).attr('id').replace('1', '0');
            let filtered = $('#' + TargetId).find('.scroll-section .checkbox-section .same-checkbox');
            $(filtered).filter(function () {
                $(this).toggle($(this).text().toLowerCase().indexOf(val) > -1)
            });
        }
        catch (error) { }
    }
    handleFilter = e => {
        try {
            let TargetName = $(e.target).attr('name');
            let val = e.target.value.toLowerCase();
            let TargetId = $(e.target).attr('id').replace('1', '0');
            if (TargetName != 'PhStateInput' && TargetName != 'PrStateInput' && TargetName != 'PBMInput') {
                if ($(e.target).val().length >= 3) {
                    this.setState({ PhZIPCODE: $(e.target).val() });
                    let stext = $(e.target).val();
                    let TargetJson = this.SelectedSearchTypeItemList($(e.target).attr('scroll-id'));
                    this.GetNewItem_Search_LazyLoading($(e.target).val(), $(e.target).attr('scroll-id'), this.state.userdata.userrole.toString(), this.state.userdata.distributor_UserId.toString(), this.state.userdata.wholesaler_Id.toString(), JSON.stringify(JSON.parse(TargetJson)["dataset"]), 'TypeSearch', TargetId);
                    this.clearSectionLoading($(e.target).attr('scroll-id'));
                }
                else {
                    let filtered = $('#' + TargetId).find('.scroll-section .checkbox-section .same-checkbox');
                    if ($(e.target).val() == '' || $(e.target).val() == null || $(e.target).val() == undefined) {
                        let filtered = $('#' + TargetId).find('.scroll-section .checkbox-section .same-checkbox');
                        $(filtered).filter(function () {

                            if ($(this).css('display', 'none')) {
                                $(this).toggle();
                            }
                        });
                        this.clearSectionLoading($(e.target).attr('scroll-id'));
                    }
                }
            }
        }
        catch (error) {

        }
    }

    SelectedSearchTypeItemList(inputname) {
        let CreatedJson = '';
        let CreatedTagList = $('div[datascroll="' + inputname + '"]').find('label');
        if (CreatedTagList.length > 0) {
            try {
                let JsonData = '';
                let UnodeValue = '';
                let textval = '';
                for (var it = 0; it < CreatedTagList.length; it++) {
                    textval = '';
                    textval = CreatedTagList[it].innerText;
                    if (UnodeValue == '') {
                        UnodeValue = "\"" + textval.trim() + "\"";
                    }
                    else {
                        if (UnodeValue.toLowerCase().indexOf(textval.trim().toLowerCase()) == -1) {
                            UnodeValue = UnodeValue + ',' + "\"" + textval.trim() + "\"";
                        }
                    }
                }
                JsonData = "\"" + "ItemList" + "\"" + ': [' + UnodeValue + ']';
                JsonData = '{' + "\"" + "dataset" + "\"" + ': {' + JsonData + '}}';
                CreatedJson = JsonData;
            }
            catch (error) {
            }
            return CreatedJson;
        }
    }
    GetNewItem_Search_LazyLoading(stext, stype, roletype, rolename, whname, itemlist, FilterType, TagId) {

        try {

            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'requestHeader': itemlist },
                body: JSON.stringify({ stext, stype, roletype, rolename, whname })
            };
            return fetch(`/api/Filter/LazyLoadingData`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        const listState = this.getLazyLoadListState(stype);
                        let addedCount = 0;
                        if (listState) {
                            const merged = this.mergeLazyLoadItems(listState.list, apidata);
                            addedCount = merged.addedCount;
                            this.setState({ [listState.stateKey]: merged.newArr });
                        }
                        if (FilterType != 'scroll') {
                            let filtered = $('#' + TagId).find('.scroll-section .checkbox-section .same-checkbox');
                            stext = stext.toLowerCase();
                            $(filtered).filter(function (value, index, array) {
                                $(this).toggle($(this).text().toLowerCase().indexOf(stext) > -1)
                            });

                        }
                        if (FilterType === 'scroll') {
                            if (addedCount === 0) {
                                this.hasReachedEnd[stype] = true;
                            }
                            this.finishScrollLoading(stype, addedCount > 0);
                        }
                    }
                    catch (error) {
                        if (FilterType === 'scroll') {
                            this.hasReachedEnd[stype] = true;
                            this.finishScrollLoading(stype, false);
                        }
                    }
                })
                .catch(() => {
                    if (FilterType === 'scroll') {
                        this.canLoadMore[stype] = true;
                        this.finishScrollLoading(stype, true);
                    }
                });


        }
        catch (error) {
        }
    }

    handleCheckbox(e) {
        var currentCheckbox = $(e.target).attr('name');
        var currentCheckboxvalue = $(e.target).attr('value');
        const isChecked = e.target.checked;
        //open if required for holesaler entity
        //var currentCheckboxtext = $(e.target).attr('text');
        
        // Use longer delay to ensure React has fully completed rendering
        const performDOMUpdate = () => {
            var mainDiv, close, spanElement;
            
            if (isChecked) {
                try {
                    // Check if selectFilter div exists before proceeding
                    const selectFilterDiv = document.querySelector('.selectFilter');
                    
                    if (!selectFilterDiv) {
                        setTimeout(performDOMUpdate, 20);
                        return;
                    }
                    
                    mainDiv = document.createElement("DIV");
                    mainDiv.setAttribute("class", "selected-filter-name");
                    close = document.createElement("span");
                    close.setAttribute("class", "close");
                    close.setAttribute("data-id", currentCheckbox + '_' + currentCheckboxvalue);
                    if (/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) {
                        mainDiv.appendChild(close);
                    } else {
                        mainDiv.append(close);
                    }
                    spanElement = document.createElement("span");
                    spanElement.setAttribute("class", "city-name");
                    spanElement.setAttribute("tagid", currentCheckbox + '_' + currentCheckboxvalue);
                    spanElement.setAttribute("nodename", currentCheckbox);
                    spanElement.setAttribute("nodevalue", currentCheckboxvalue);
                    let tagspantext = currentCheckboxvalue;
                    //open if required for holesaler entity
                    //if (currentCheckbox == "WholesalerName") {
                    //    spanElement.setAttribute("nodetext", currentCheckboxtext);
                    //    tagspantext = currentCheckboxtext;
                    //} else {
                    //    tagspantext = currentCheckboxvalue;
                    //}

                    try {
                        if (tagspantext.length >= 10) {
                            tagspantext = tagspantext.substring(0, 7) + '...';
                        }
                    }
                    catch (error) { }
                    spanElement.innerHTML = tagspantext;
                    if (/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) {
                        mainDiv.appendChild(spanElement);
                    } else {
                        mainDiv.append(spanElement);
                    }
                    
                    // Use native DOM append for better reliability
                    selectFilterDiv.appendChild(mainDiv);
                    $('#errormsg').text("");
                    // return false;
                    
                    // Setup close button click handler
                    try {
                        close.onclick = function (e) {
                            var currentclosetag = $(e.target).attr('data-id').split('_')[0];
                            var currentclosecheckbox = $(e.target).attr('data-id').split('_')[1];
                            try {
                                if (currentclosetag === 'Group Prefix') {
                                    let filtered = $('#PhGPrefixInput0').find('.scroll-section .checkbox-section .same-checkbox');
                                    $(filtered).filter(function () {
                                        $(this).find('input:checkbox[name="' + currentclosetag + '"][value="' + currentclosecheckbox + '"]').prop("checked", false);
                                    });
                                }
                                else {
                                    let filtered = $('#' + currentclosetag + 'Input0').find('.scroll-section .checkbox-section .same-checkbox');
                                    $(filtered).filter(function () {
                                        $(this).find('input:checkbox[name="' + currentclosetag + '"][value="' + currentclosecheckbox + '"]').prop("checked", false);
                                    });
                                }
                                try {
                                    let utagid = currentclosetag + '_' + currentclosecheckbox;
                                    $('span[tagid="' + utagid + '"]').parent().remove();
                                    if ($('.selectFilter').find('span').length <= 0) {
                                        $('#errormsg').text("Please make a selection above");
                                    }
                                } catch (error) {

                                }
                            }
                            catch (error) {
                            }
                        }
                    }
                    catch (error) { }
                }
                catch (error) { }
            } else {
                try {
                    let TagID = currentCheckbox + '_' + currentCheckboxvalue;
                    $('span[tagid="' + TagID + '"]').parent().remove();
                    if ($('.selectFilter').find('span').length <= 0) {
                        $('#errormsg').text("Please make a selection above");
                    }
                    //return false;
                }
                catch (error) { }
            }
        };
        
        // Use longer delay - 50ms should be enough for React to complete render cycle
        setTimeout(performDOMUpdate, 50);
    }

    componentDidMount() {
        this.fetchPrescriberInfo();
        if (this.state.userdata.userrole == "Distributor" && this.state.userdata.wholesaler == "Avenel") {
            this.GetFilterRawDataDetail(this.state.RoleName, this.state.RoleType, this.state.userdata.wholesaler_Id, this.state.userdata.distributor_UserId);
        }
        else if (this.state.userdata.userrole == "Distributor" && this.state.userdata.wholesaler != "Avenel") {
            this.GetFilterRawDataDetail(this.state.RoleName, this.state.RoleType, this.state.userdata.wholesaler_Id, this.state.userdata.distributor_UserId);
        }
        else {
            this.GetFilterRawDataDetail(this.state.RoleName, this.state.RoleType, this.state.userdata.wholesaler_Id, -1);
        }
        //this.GetFilterRawDataDetail(this.state.RoleName, this.state.RoleType, this.state.userdata.wholesaler_Id);
        document.addEventListener('scroll', this.trackScrolling);
        setTimeout(() => {
            $('.popup').addClass('mfp-ready');
            $('.popup').addClass('mfp-bg');
            $('.popup').addClass('mfp-with-anim');
        }, 5);
    }


    GetLazyLoadingDataUserTupe(Type, ToSkip, Roletype, RoleName) {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Type, ToSkip, Roletype, RoleName })
            };
            return fetch(`/api/Filter/LazyLoadingDataUserType`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        if (apidata.length > 0) {
                            for (let i = 0; i < apidata[0]["fgroups"].length; i++) {
                                //this.state.PharmacyJson.push(apidata[0]["fpharmacy"][i]);
                                this.state.GroupNameJson.push(apidata[0]["fgroups"][i]);
                            }

                            if (Type != "GROUPNUMBER") {
                                this.MakeListDistinctType(Type);
                            }

                            this.clearSectionLoading(Type);
                        }
                        else {
                            this.clearSectionLoading(Type);
                        }
                    }
                    catch (error) {
                        this.clearSectionLoading(Type);
                    }
                });
        }
        catch (error) {
            this.clearSectionLoading(Type);
        }
    }

    handleScroll = e => {
        let section;
        try {
            const element = e.target;
            section = $(e.target).attr('datascroll');
            const isAtBottom = element.scrollHeight - element.scrollTop <= element.clientHeight + 1;

            if (this.hasReachedEnd[section]) return;

            if (!isAtBottom) {
                this.canLoadMore[section] = true;
                return;
            }

            if (this.isAnySectionLoading()) return;
            if (this.isScrollLoading[section] || this.canLoadMore[section] === false) return;

            this.canLoadMore[section] = false;
            this.isScrollLoading[section] = true;
            this.setSectionLoading(section, true);

            const itemListJson = this.SelectedSearchTypeItemList(section);
            if (!itemListJson) {
                this.clearSectionLoading(section);
                return;
            }
            const itemlist = JSON.stringify(JSON.parse(itemListJson)["dataset"]);
            this.GetNewItem_Search_LazyLoading('', section, this.state.userdata.userrole.toString(), this.state.userdata.distributor_UserId.toString(), this.state.userdata.wholesaler_Id.toString(), itemlist, 'scroll', '');
        }
        catch (error) {
            if (section) {
                this.clearSectionLoading(section);
            }
        }
    }

    HandleApplyFilter = e => {
        try {
            if ($('.selectFilter').find('span').length <= 0) {
                $('#errormsg').text("Please make a selection above");
                return false;
            }
            else {
                localStorage.setItem('Advance_Filter', JSON.stringify(JSON.parse(this.SelectedTagJsonBuilding())["dataset"]));
                window.location.href = window.location.origin + '/dashboard'
            }
        } catch (error) {
        }
    }
    HandleResetFilter = e => {
        try {
            $('input[type=checkbox]').prop("checked", false);
            $(".selectFilter").html('');

            $(".searchFilter").each(function () {
                if ($(this).val() != '') {

                    let TargetId = $(this).attr('id').replace('1', '0');
                    let filtered = $('#' + TargetId).find('.scroll-section .checkbox-section .same-checkbox');
                    $(filtered).filter(function () {
                        if ($(this).css('display', 'none')) {
                            $(this).toggle();
                        }
                    });
                    $(this).val("");
                }
            });

        } catch (error) {
        }
    }

    SelectedTagJsonBuilding() {
        var CreatedJson = '';
        try {
            let CreatedTagList = $('.selectFilter').find('.city-name');
            if (CreatedTagList.length > 0) {
                var nodes = [], values = [];
                for (var i = 0; i < CreatedTagList.length; i++) {
                    nodes.push($(CreatedTagList[i]).attr('nodename'));
                }
                var uniquenodes = nodes.filter((v, i, a) => a.indexOf(v) === i);
                try {
                    let JsonData = '';
                    for (var i = 0; i < uniquenodes.length; i++) {
                        let UnodeName = uniquenodes[i];
                        let UnodeValue = '';
                        let UnodeText = '';
                        for (var j = 0; j < CreatedTagList.length; j++) {
                            if ($(CreatedTagList[j]).attr('nodename') == UnodeName) {
                                if (UnodeValue == '') {
                                    //open all commented if required for holesaler entity
                                    //if (UnodeName == "WholesalerName") {
                                    //    UnodeValue = "\"" + $(CreatedTagList[j]).attr('nodevalue') + "\"";
                                    //    UnodeText = "\"" + $(CreatedTagList[j]).attr('nodetext') + "\"";
                                    //}
                                    //else {
                                    UnodeValue = "\"" + $(CreatedTagList[j]).attr('nodevalue') + "\"";
                                    //UnodeText = "\"" + $(CreatedTagList[j]).attr('nodetext') + "\"";
                                    //}
                                }
                                else {
                                    //if (UnodeName == "WholesalerName") {
                                    //    UnodeValue = UnodeValue + ',' + "\"" + $(CreatedTagList[j]).attr('nodevalue') + "\"";
                                    //    UnodeText = UnodeText + ',' + "\"" + $(CreatedTagList[j]).attr('nodetext') + "\"";
                                    //}
                                    //else {
                                    UnodeValue = UnodeValue + ',' + "\"" + $(CreatedTagList[j]).attr('nodevalue') + "\"";
                                    //UnodeText = UnodeText + ',' + "\"" + $(CreatedTagList[j]).attr('nodetext') + "\"";
                                    //}
                                }
                            }
                        }
                        if (JsonData == '') {
                            //if (UnodeName == "WholesalerName") {
                            //    JsonData = "\"" + UnodeName + "\"" + ': [' + UnodeText + ']';
                            //    JsonData = JsonData + "," + "\"" + 'Wholesaler_Id' + "\"" + ': [' + UnodeValue + ']';
                            //    //JsonData = "\"" + UnodeName + "\"" + ': [{' + UnodeName + ':' + "\"" + UnodeText + "\"" + ',' + "\"" + 'Wholesaler_Id' + "\"" + ':' + UnodeValue + '}]';
                            //}
                            //else {
                            JsonData = "\"" + UnodeName + "\"" + ': [' + UnodeValue + ']';
                            //}
                        }
                        else {
                            //if (UnodeName == "WholesalerName") {
                            //    JsonData = JsonData + "," + "\"" + UnodeName + "\"" + ': [' + UnodeText + ']';
                            //    JsonData = JsonData + "," + "\"" + 'Wholesaler_Id' + "\"" + ': [' + UnodeValue + ']';
                            //    //JsonData = JsonData + "," + "\"" + UnodeName + "\"" + ': [{' + UnodeName + ':' + "\"" + UnodeText + "\"" + ',' + "\"" + 'Wholesaler_Id' + "\"" + ':' + UnodeValue + '}]';
                            //}
                            //else {
                            JsonData = JsonData + "," + "\"" + UnodeName + "\"" + ': [' + UnodeValue + ']';
                            //}
                        }
                    }
                    JsonData = '{' + "\"" + "dataset" + "\"" + ': {' + JsonData + '}}';
                    CreatedJson = JsonData;
                }
                catch (error) {

                }
            }

        } catch (error) {
        }
        return CreatedJson;
    }
    HandleSearchFocus = e => {
        $('#FilterNameText').css('border-color', '#dde5ed');
        $('#errormsg').text("");
        $('#FilterNameText').removeClass('errorIcon');
    }
    resetColor = e => {
        $('.btn').addClass('changeColor');
    }
    changeClass = e => {
        $('.btn').removeClass('changeColor');
    }
    render() {

        let len = 0;
        try {
            len = this.state.CityJson.length + this.state.StateJson.length + this.state.ZipJson.length + this.state.PbmJson.length;
        }
        catch (error) {
            len = 0;
        }

        if (len > 0) {
            return (
                <div className='popup mfp-zoom-in CreateNewFilter'>
                    <div className='popup_inner'>
                        <h1>{this.props.text}<button onClick={this.props.closePopup}>X</button></h1>

                        <div className="filter-Content TransitionsPopup">
                            <div className="filter-scroll theme-checkbox">
                                {/*---------New Filter Row--*/}
                                {this.state.userdata.username != 'ID.me' && this.state.userdata.email != 'alex.von.reyn@id.me' ?
                                    <div className="repeat-section" id="PhCityInput0">
                                        <h3>Pharmacy City</h3>
                                        <div className="searchSection">
                                            <img className="SearchIcon" src={Search_Icon} alt="" />
                                            <form autoComplete="off">
                                                <div className="autocomplete">
                                                    <input id="PhCityInput1" type="text" name="PhCityInput" scroll-id="CITY" data-id="dynamic" placeholder="Search" onKeyUp={this.handleFilter} className="form-control searchFilter" />
                                                </div>
                                            </form>
                                        </div>
                                        <div className="scroll-section" datascroll="CITY" onScroll={this.handleScroll}>
                                            {

                                                this.state.CityJson != null ? this.state.CityJson[0] ?
                                                    <div className="checkbox-section" key={"CityList"}>
                                                        {this.state.CityJson.map((e1, i1) => {
                                                            return (
                                                                <div className="same-checkbox" key={'PhCity' + i1}> <label><input id={'PhCity' + i1} type="checkbox" onChange={this.handleCheckbox} name="PhCity" value={e1.text} /><span className="checkmark"></span><label for={'PhCity' + i1}>{e1.text}</label></label></div>
                                                            )
                                                        })}
                                                        {this.state.loading.CITY ? <div className="theme-loader resetLoader scroll-loader"></div> : null}
                                                    </div> : null : null
                                            }

                                        </div>
                                    </div> : null
                                }
                                {this.state.userdata.username != 'ID.me' && this.state.userdata.email != 'alex.von.reyn@id.me' ?
                                    <div className="repeat-section gap" id="PhStateInput0">
                                        <h3>Pharmacy State</h3>
                                        <div className="searchSection">
                                            <img className="SearchIcon" src={Search_Icon} alt="" />
                                            <form autoComplete="off">
                                                <div className="autocomplete">
                                                    <input id="PhStateInput1" type="text" name="PhStateInput" placeholder="Search" onKeyUp={this.handleFilter_static} className="form-control searchFilter" />
                                                </div>
                                            </form>
                                        </div>
                                        <div className="scroll-section">
                                            {

                                                this.state.StateJson != null ? this.state.StateJson[0] ?
                                                    <div className="checkbox-section" key={"PhStateList"}>
                                                        {this.state.StateJson.map((e1, i1) => {
                                                            return (
                                                                <div className="same-checkbox" key={'PhState' + i1}> <label><input type="checkbox" id={'PhState' + i1} onChange={this.handleCheckbox} name="PhState" value={e1.text} /><span className="checkmark"></span><label for={'PhState' + i1}>{e1.text}</label></label></div>
                                                            )
                                                        })}

                                                    </div> : null : null
                                            }
                                        </div>
                                    </div> : null
                                }
                                {this.state.userdata.username != 'ID.me' && this.state.userdata.email != 'alex.von.reyn@id.me' ?
                                    <div className="repeat-section" id="PhZipInput0">
                                        <h3>Pharmacy Zip</h3>
                                        <div className="searchSection">
                                            <img className="SearchIcon" src={Search_Icon} alt="" />
                                            <form autoComplete="off">
                                                <div className="autocomplete">
                                                    <input id="PhZipInput1" type="text" name="PhZipInput" scroll-id="ZIP" placeholder="Search" onKeyUp={this.handleFilter} className="form-control searchFilter" />
                                                </div>
                                            </form>
                                        </div>
                                        <div className="scroll-section" datascroll="ZIP" onScroll={this.handleScroll}>
                                            {

                                                this.state.ZipJson != null ?

                                                    <div className="checkbox-section" key={"PhZipList"}>
                                                        {this.state.ZipJson.map((e1, i1) => {
                                                            return (
                                                                <div className="same-checkbox" key={'PhZip' + i1}><label> <input type="checkbox" id={'PhZip' + i1} onChange={this.handleCheckbox} name="PhZip" value={e1.text} /><span className="checkmark"></span><label for={'PhZip' + i1}>{e1.text}</label></label></div>
                                                            )
                                                        })}
                                                        {this.state.loading.ZIP ? <div className="theme-loader resetLoader scroll-loader"></div> : null}

                                                    </div> : null
                                            }
                                        </div>
                                    </div> : null
                                }

                                {/*---------New Filter Row--*/}

                                {/*---------New Filter Row--*/}
                                <div className="repeat-section" id="PBMInput0">
                                    <h3>PCN</h3>
                                    <div className="searchSection">
                                        <img className="SearchIcon" src={Search_Icon} alt="" />
                                        <form autoComplete="off">
                                            <div className="autocomplete">
                                                <input id="PBMInput1" type="text" name="PBMInput" placeholder="Search" onKeyUp={this.handleFilter_static} className="form-control searchFilter" />
                                            </div>
                                        </form>
                                    </div>
                                    <div className="scroll-section pcn_text_caps">
                                        {

                                            this.state.PbmJson != null ? this.state.PbmJson[0] ?
                                                <div className="checkbox-section" key={"PbmlistList"}>
                                                    {this.state.PbmJson.map((e1, i1) => {
                                                        return (
                                                            <div className="same-checkbox" key={'PBM' + i1}> <label><input type="checkbox" id={'PBM' + i1} onChange={this.handleCheckbox} name="PBM" value={e1.text} /><span className="checkmark"></span><label for={'PBM' + i1}>{e1.text}</label></label></div>
                                                        )
                                                    })}
                                                </div> : null : null

                                        }
                                    </div>
                                </div>
                                <div className="repeat-section gap" id="DrugNameInput0">
                                    <h3>Drug Name</h3>
                                    <div className="searchSection">
                                        <img className="SearchIcon" src={Search_Icon} alt="" />
                                        <form autoComplete="off">
                                            <div className="autocomplete">
                                                <input id="DrugNameInput1" type="text" name="DrugNameInput" scroll-id="DRUG" placeholder="Search" onKeyUp={this.handleFilter} className="form-control searchFilter" />
                                            </div>
                                        </form>
                                    </div>
                                    <div className="scroll-section" datascroll="DRUG" onScroll={this.handleScroll}>
                                        {

                                            this.state.DrugJson != null ? this.state.DrugJson[0] ?
                                                <div className="checkbox-section" key={"DrugList"}>
                                                    {this.state.DrugJson.map((e1, i1) => {
                                                        return (
                                                            <div className="same-checkbox" key={'DrugName' + i1}> <label><input id={'DrugName' + i1} type="checkbox" onChange={this.handleCheckbox} name="DrugName" value={e1.text} /><span className="checkmark"></span><label for={'DrugName' + i1}>{e1.text}</label></label></div>
                                                        )
                                                    })}
                                                    {this.state.loading.DRUG ? <div className="theme-loader resetLoader scroll-loader"></div> : null}
                                                </div> : null : null
                                        }
                                    </div>
                                </div>
                                <div className="repeat-section" id="PharmacyNameInput0">
                                    <h3>Pharmacy Name</h3>
                                    <div className="searchSection">
                                        <img className="SearchIcon" src={Search_Icon} alt="" />
                                        <form autoComplete="off">
                                            <div className="autocomplete">
                                                <input id="PharmacyNameInput1" type="text" name="PharmacyNameInput" scroll-id="PHARMACYNAME" placeholder="Search" onKeyUp={this.handleFilter} className="form-control searchFilter" />
                                            </div>
                                        </form>
                                    </div>
                                    <div className="scroll-section" datascroll="PHARMACYNAME" onScroll={this.handleScroll}>
                                        {

                                            this.state.PharmacyJson != null ? this.state.PharmacyJson[0] ?
                                                <div className="checkbox-section" key={"PharmacyNameList"}>
                                                    {this.state.PharmacyJson.map((e1, i1) => {
                                                        return (
                                                            <div className="same-checkbox" key={'PharmacyName' + i1}> <label><input id={'PharmacyName' + i1} type="checkbox" onChange={this.handleCheckbox} name="PharmacyName" value={e1.text} /><span className="checkmark"></span><label for={'PharmacyName' + i1}>{e1.text}</label></label></div>
                                                        )
                                                    })}
                                                    {this.state.loading.PHARMACYNAME ? <div className="theme-loader resetLoader scroll-loader"></div> : null}
                                                </div> : null : null
                                        }
                                    </div>
                                </div>

                                {/*---------New Filter Row--*/}
                                {((this.state.prescribe_status === true && (this.state.userdata.userrole === 'Wholesaler' || this.state.userdata.userrole === 'Distributor')) || (this.state.userdata.userrole === "Admin" || this.state.userdata.userrole === "SubAdmin")) ?
                                    //{/*&& (this.state.userdata.wholesaler.toLowerCase() != 'trustcare health, llc' && this.state.userdata.wholesaler.toLowerCase() != 'medresults, llc')?*/ }
                                    <div className="repeat-section" id="PrescriberInput0">
                                        <h3>Prescriber Name</h3>
                                        <div className="searchSection">
                                            <img className="SearchIcon" src={Search_Icon} alt="" />
                                            <form autoComplete="off">
                                                <div className="autocomplete">
                                                    <input id="PrescriberInput1" type="text" name="PrescriberInput" scroll-id="PRESCRIBERNAME" placeholder="Search" onKeyUp={this.handleFilter} className="form-control searchFilter" />
                                                </div>
                                            </form>
                                        </div>
                                        <div className="scroll-section" datascroll="PRESCRIBERNAME" onScroll={this.handleScroll}>
                                            {

                                                this.state.PrescriberJson != null ? this.state.PrescriberJson[0] ?
                                                    <div className="checkbox-section" key={"PrescriberList"}>
                                                        {this.state.PrescriberJson.map((e1, i1) => {
                                                            return (
                                                                <div className="same-checkbox" key={'Prescriber' + i1}><label> <input type="checkbox" id={'Prescriber' + i1} onChange={this.handleCheckbox} name="Prescriber" value={e1.text} /><span className="checkmark"></span><label for={'Prescriber' + i1}>{e1.text}</label></label></div>
                                                            )
                                                        })}
                                                        {this.state.loading.PRESCRIBERNAME ? <div className="theme-loader resetLoader scroll-loader"></div> : null}
                                                    </div> : null : null

                                            }
                                        </div>
                                    </div> : null
                                }
                                <div className="repeat-section" id="GroupNumberInput0">
                                    <h3>Group Number</h3>
                                    <div className="searchSection">
                                        <img className="SearchIcon" src={Search_Icon} alt="" />
                                        <form autoComplete="off">
                                            <div className="autocomplete">
                                                <input id="GroupNumberInput1" type="text" name="GroupNumberInput" scroll-id="GROUPNUMBER" placeholder="Search" onKeyUp={this.handleFilter} className="form-control searchFilter" />
                                            </div>
                                        </form>
                                    </div>
                                    <div className="scroll-section" datascroll="GROUPNUMBER" onScroll={this.handleScroll}>
                                        {

                                            this.state.GroupNameJson != null ? this.state.GroupNameJson[0] ?
                                                <div className="checkbox-section" key={"GroupNumberList"}>
                                                    {this.state.GroupNameJson.map((e1, i1) => {
                                                        return (
                                                            <div className="same-checkbox" key={'GroupNumber' + i1}> <label><input id={'GroupNumber' + i1} type="checkbox" onChange={this.handleCheckbox} name="GroupNumber" value={e1.text} /><span className="checkmark"></span><label for={'GroupNumber' + i1}>{e1.text}</label></label></div>
                                                        )
                                                    })}
                                                    {this.state.loading.GROUPNUMBER ? <div className="theme-loader resetLoader scroll-loader"></div> : null}
                                                </div> : null : null
                                        }
                                    </div>
                                </div>
                                {
                                    this.state.userdata.userrole != "Distributor" && this.state.DistributorJson != null && this.state.DistributorJson.length > 0 ?
                                        <div className="repeat-section" id="DistributorNameInput0">
                                            <h3>Distributor Name</h3>
                                            <div className="searchSection">
                                                <img className="SearchIcon" src={Search_Icon} alt="" />
                                                <form autoComplete="off">
                                                    <div className="autocomplete">
                                                        <input id="DistributorNameInput1" type="text" name="DistributorNameInput" scroll-id="DISTRIBUTOR" placeholder="Search" onKeyUp={this.handleFilter} className="form-control searchFilter" />
                                                    </div>
                                                </form>
                                            </div>
                                            <div className="scroll-section" datascroll="DISTRIBUTOR" onScroll={this.handleScroll}>
                                                {

                                                    this.state.DistributorJson != null ? this.state.DistributorJson[0] ?
                                                        <div className="checkbox-section" key={"DistributorNameList"}>
                                                            {this.state.DistributorJson.map((e1, i1) => {
                                                                return (
                                                                    <div className="same-checkbox" key={'DistributorName' + i1}><label> <input type="checkbox" id={'DistributorName' + i1} onChange={this.handleCheckbox} name="DistributorName" value={e1.text} /><span className="checkmark"></span><label for={'DistributorName' + i1}>{e1.text}</label></label></div>
                                                                )
                                                            })}
                                                            {this.state.loading.DISTRIBUTOR ? <div className="theme-loader resetLoader scroll-loader"></div> : null}
                                                        </div> : null : null
                                                }
                                            </div>
                                        </div> : null
                                }
                                {/*---------New Filter Row--*/}
                                {
                                    this.state.userdata.userrole == "Admin" || this.state.userdata.userrole == "SubAdmin" ?
                                        <div className="repeat-section" id="WholesalerNameInput0">
                                            <h3>Wholesaler Name</h3>
                                            <div className="searchSection">
                                                <img className="SearchIcon" src={Search_Icon} alt="" />
                                                <form autoComplete="off">
                                                    <div className="autocomplete">
                                                        <input id="WholesalerNameInput1" type="text" name="WholesalerNameInput" scroll-id="WHOLESALER" placeholder="Search" onKeyUp={this.handleFilter} className="form-control searchFilter" />
                                                    </div>
                                                </form>
                                            </div>
                                            <div className="scroll-section" datascroll="WHOLESALER" onScroll={this.handleScroll}>
                                                {

                                                    this.state.WholesalerJson != null ? this.state.WholesalerJson[0] ?
                                                        <div className="checkbox-section" key={"WholesalerList"}>
                                                            {this.state.WholesalerJson.map((e1, i1) => {
                                                                return (
                                                                    //text={e1.text} value={e1.val}
                                                                    <div className="same-checkbox" key={'WholesalerName' + i1}> <label><input type="checkbox" id={'WholesalerName' + i1} onChange={this.handleCheckbox} name="WholesalerName" value={e1.text} /><span className="checkmark"></span><label for={'WholesalerName' + i1}>{e1.text}</label></label></div>
                                                                )
                                                            })}
                                                            {this.state.loading.WHOLESALER ? <div className="theme-loader resetLoader scroll-loader"></div> : null}
                                                        </div> : null : null

                                                }
                                            </div>
                                        </div> : null
                                }
                                <div className={this.state.userdata.userrole == "Admin" || this.state.userdata.userrole == "SubAdmin" ? "repeat-section gap" : "repeat-section"} id="PhBinInput0">
                                    <h3>BIN</h3>
                                    <div className="searchSection">
                                        <img className="SearchIcon" src={Search_Icon} alt="" />
                                        <form autoComplete="off">
                                            <div className="autocomplete">
                                                <input id="PhBinInput1" type="text" name="PhBinInput" placeholder="Search" onKeyUp={this.handleFilter_static} className="form-control searchFilter" />
                                            </div>
                                        </form>
                                    </div>
                                    <div className="scroll-section pcn_text_caps">
                                        {

                                            this.state.BinJson != null ? this.state.BinJson[0] ?
                                                <div className="checkbox-section" key={"BinList"}>
                                                    {this.state.BinJson.map((e1, i1) => {
                                                        return (
                                                            <div className="same-checkbox" key={'PhBin' + i1}> <label><input type="checkbox" id={'PhBin' + i1} onChange={this.handleCheckbox} name="PhBin" value={e1.text} /><span className="checkmark"></span><label for={'PhBin' + i1}>{e1.text}</label></label></div>
                                                        )
                                                    })}
                                                </div> : null : null

                                        }
                                    </div>
                                </div>
                                {
                                    this.state.userdata.userrole === "Admin" ?
                                        <div className="repeat-section" id="PhGPrefixInput0">
                                            <h3>Group Prefix</h3>
                                            <div className="searchSection">
                                                <img className="SearchIcon" src={Search_Icon} alt="" />
                                                <form autoComplete="off">
                                                    <div className="autocomplete">
                                                        <input id="PhGPrefixInput1" type="text" name="PhGPrefix" placeholder="Search" onKeyUp={this.handleFilter_static} className="form-control searchFilter" />
                                                    </div>
                                                </form>
                                            </div>
                                            <div className="scroll-section pcn_text_caps">
                                                {

                                                    this.state.GroupPrefixJson != null ? this.state.GroupPrefixJson[0] ?
                                                        <div className="checkbox-section" key={"GPrefixJsonList"}>
                                                            {this.state.GroupPrefixJson.map((e1, i1) => {
                                                                return (
                                                                    <div className="same-checkbox" key={'PhGPrefix' + i1}> <label><input type="checkbox" id={'PhGPrefix' + i1} onChange={this.handleCheckbox} name="Group Prefix" value={e1.text} /><span className="checkmark"></span><label for={'PhGPrefix' + i1}>{e1.text}</label></label></div>
                                                                )
                                                            })}
                                                        </div> : null : null

                                                }
                                            </div>
                                        </div> : null
                                }
                            </div>
                            <div className="selected-filters">
                                <label>Selected Filters</label>
                                <div className="selectFilter"></div>
                            </div>
                            <div className="save-filter-section">
                                <h3>Save Filter</h3>
                                <h4>Name</h4>
                                <input type="text" id="FilterNameText" className="form-control" placeholder="Filter set 1" onFocus={this.HandleSearchFocus} />
                                <div className="btn-section">
                                    <button className="btn first-one btn-theme-color" onClick={this.HandleSaveFilter}>Save</button>
                                    <button className="btn save btn-theme-color" onClick={this.HandleCancelSaveFilter}>Cancel</button>
                                </div>
                                <div className="arrow-down">&nbsp;</div>
                            </div>
                        </div>
                        <div className="btn-section">
                            <button className="btn apply-filter btn-theme-color" onClick={this.HandleApplyFilter}>Apply Filter</button>
                            <button onMouseOut={this.resetColor} onMouseOver={this.changeClass} className="btn reset btn-theme-color" onClick={this.HandleResetFilter}>Reset</button>
                            <button className="btn save btn-theme-color" onClick={this.saveFilter}>Save Filter</button>
                            <div class="help-block alert-danger" id="errormsg"></div>
                        </div>

                    </div>
                </div>
            );
        }
        else {
            return (
                <div className='popup mfp-zoom-in CreateNewFilter'>
                    <div className='popup_inner'>
                        <h1>{this.props.text}<button onClick={this.props.closePopup}>X</button></h1>
                        <div className="WhCommission">
                            <div className="theme-loader"></div>
                            <div className="filter-Content TransitionsPopup wait">
                                <h3>Please wait...</h3>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

export default CreateNewFilter;